import { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { StyledStack } from "./Gallery.style";
import DrawerCM from "components/shared/Drawer";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import useHttp from "hooks/use-http";
import {
  getGalleryRequest,
  deleteGalleryRequest,
  addGalleryRequest,
} from "api/requests";
import { validateImg } from "validations";

function Gallery() {
  const [image, setImage] = useState({ data: [], count: 0 });
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp();

  const onSubmit = async (image) => {
    validateImg(image);
    const res = await request({
      url: () =>
        addGalleryRequest(image, (progress) => setUploadProgress(progress)),
      isFile: true,
    });

    if (res) Toast({ type: "success", title: "آپلود عکس" });
    getImages();
  };

  const handelDelete = async (id) => {
    const res = await request({
      url: deleteGalleryRequest,
      values: id,
    });
    if (res) Toast({ type: "success", title: "حذف" });
    getImages();
  };

  const getImages = useCallback(async () => {
    const res = await request({
      url: getGalleryRequest,
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        image: items.image,
      }));

      setImage({ data: transformedData, count: res.count });
    }
  }, [request]);

  useEffect(() => {
    getImages();
  }, [getImages]);

  return (
    <DrawerCM title="تصاویر گالری">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={2}>
          <StyledStack>
            <Grid container my={1} spacing={2}>
              <Grid item md={4} sm={6} xs={12}>
                <Upload
                  refillable
                  onChange={(values) => onSubmit(values)}
                  type="addimage"
                />
              </Grid>
              {image.data.map((items, index) => {
                return (
                  <Grid item md={4} sm={6} xs={12} key={"gallery-img" + index}>
                    <Upload
                      file={items.image}
                      isWeb
                      type="gallery-images"
                      onDelete={() => handelDelete(items.id)}
                      width="100%"
                      height="100%"
                      objectFit="contain"
                    />
                  </Grid>
                );
              })}
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
export default Gallery;
